/**
 * Viewer Dashboard Bootstrap
 *
 * Single source of truth for entering shared-dashboard viewer mode across
 * every dashboard variant (English + all localized siblings). Must load
 * BEFORE admin.js and before the per-page inline auth scripts.
 *
 * Why this exists: viewer links (?viewerToken=) are language-agnostic and the
 * per-language dashboards each have their own inline auth flow. Previously
 * only the English dashboard detected the token; localized dashboards fell
 * through to the normal owner-auth flow and showed recipients a misleading
 * "this event isn't connected to your account" error. Centralizing the
 * bootstrap here keeps all variants in lockstep and prevents that drift.
 *
 * The flag is set SYNCHRONOUSLY at script-parse time so every later auth
 * guard (inline `onAuthStateChanged`, admin.js `initAdminDashboard`) observes
 * it before any DOMContentLoaded handler runs — eliminating the race.
 */
(function () {
  var viewerToken = new URLSearchParams(window.location.search).get('viewerToken');
  if (!viewerToken) return;

  window.viewerMode = true;

  // A view-only dashboard is the Responses tab and nothing else (task #780).
  // Done as CSS on a root class, set here at parse time, rather than by
  // hiding elements once: admin.js's hideEditControls() runs a single pass
  // one second after load, and everything drawn after it - the other tabs,
  // the header's bell / edit / share buttons (shown by dashboard-quick-
  // actions.js at 0.5s and 1.5s), Import, and every row's edit pencil on each
  // re-render - came back. A stylesheet rule cannot be outrun.
  document.documentElement.classList.add('viewer-mode');
  var viewerCss = document.createElement('style');
  viewerCss.id = 'viewer-mode-styles';
  viewerCss.textContent = [
    // Every tab but Responses (the li where :has is supported, the button everywhere).
    'html.viewer-mode #dashboardTabs > .nav-item:not(:has(#responses-tab)),',
    'html.viewer-mode #dashboardTabs .nav-link:not(#responses-tab),',
    // Host-only controls: adding, importing, editing, approving, renaming.
    'html.viewer-mode #add-guest-btn, html.viewer-mode #import-responses-btn,',
    'html.viewer-mode .cell-actions, html.viewer-mode th.col-actions, html.viewer-mode .cfh-rename-btn,',
    // Header: notifications, edit form, share access, and My Events (not theirs).
    'html.viewer-mode #header-response-notif-btn, html.viewer-mode #header-edit-form-btn, html.viewer-mode #event-parts-edit-link,',
    'html.viewer-mode #header-share-dashboard-btn, html.viewer-mode .header-actions a[href="/my-projects"]',
    '{ display: none !important; }'
  ].join(' ');
  (document.head || document.documentElement).appendChild(viewerCss);

  // Guard against double-init (admin.js used to also call initViewerMode).
  if (window.__viewerBootstrapStarted) return;
  window.__viewerBootstrapStarted = true;

  function start() {
    console.log('📊 Viewer token detected - initializing viewer mode');

    var dashboardContainer = document.getElementById('dashboard-container');
    var authContainer = document.getElementById('user-auth-container');
    var eventsContainer = document.getElementById('user-events-container');
    if (dashboardContainer) dashboardContainer.style.display = 'block';
    if (authContainer) authContainer.style.display = 'none';
    if (eventsContainer) eventsContainer.style.display = 'none';

    // initViewerMode is defined in admin.js, which may still be loading.
    var attempts = 0;
    (function waitForInit() {
      if (typeof window.initViewerMode === 'function') {
        window.initViewerMode(viewerToken);
      } else if (attempts++ < 50) {
        setTimeout(waitForInit, 100);
      } else {
        console.error('❌ initViewerMode function not found after waiting');
      }
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
